import React from "react";
import "./SideLiteSearch.css"; // Add CSS for styling alignment

const SideLiteSearch = ({ placeholder = "Search Side Lite..." }) => {
    return (
        <div className="sidelite-search-container">
            <input
                type="text"
                className="sidelite-search-input"
                placeholder={placeholder}
            />
        </div>
    );
};

export default SideLiteSearch;
